import React from 'react';
import { styles } from './GiftCardDetails.css';

export interface GiftCardDetailsProps {
  type: 'digital' | 'physical';
  recipient: string;
  email?: string;
  address?: string;
  message?: string;
}

export const GiftCardDetails = ({ type, recipient, email, address, message }: GiftCardDetailsProps) => {
  return (
    <div className={styles.giftCardText}>
      <div>
        <p>
          <b>{type === 'physical' ? 'Posting to' : 'Emailing to'}</b>
        </p>
        <p>{recipient}</p>
        <p>{type === 'digital' ? email : address}</p>
      </div>
      {message ? (
        <div>
          <p>
            <b>Message</b>
          </p>
          <p>{message}</p>
        </div>
      ) : null}
    </div>
  );
};
